import { TOKEN_KEY, USER_KEY, MEMBERSHIP_TYPE_KEY } from "../../utils/Constant";
import {
  USER_LOADED,
  USER_LOADING,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
} from "../actions/types";

const initialState = {
  token: localStorage.getItem(TOKEN_KEY),
  isAuthenticated: null,
  isLoading: false,
  user: null
};

/* eslint import/no-anonymous-default-export: [2, {"allowAnonymousFunction": true}] */
export default function (state = initialState, action) {
  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case USER_LOADED:
      return {
        // ...state,
        token: action.payload.token,
        isAuthenticated: true,
        isLoading: false,
        user: action.payload,
      };

    case LOGIN_SUCCESS:
    case REGISTER_SUCCESS:
    localStorage.setItem(TOKEN_KEY, action.payload.token);
    localStorage.setItem(USER_KEY, JSON.stringify(action.payload));
    localStorage.setItem(MEMBERSHIP_TYPE_KEY, action.payload.total_order == 0 ? "New" : "Existing"); // Added by Anurag Chauhan ON 14-07-2025 TASK #161240 - Update membership type to use total_order count
      return {
        ...state,
        token: action.payload.token,
        isAuthenticated: true,
        isLoading: false,
        user: action.payload
      };

    case AUTH_ERROR:
      localStorage.removeItem(USER_KEY);
      return {
        // token: null,
        user: null,
        isAuthenticated: false,
        isLoading: false,
      };
    case LOGIN_FAIL:
    case LOGOUT_SUCCESS:
    case REGISTER_FAIL:
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      return {
        // token: null,
        user: null,
        isAuthenticated: false,
        isLoading: false,
      };

    default:
      return state;
  }
}
